import React from "react";
import { Button, Intent, Alert } from "@blueprintjs/core";
import { Icon } from "../../../atoms/Icon";
import styles from "./SubscriptionAlert.module.scss";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import useAuthState from "../../../hooks/useAuthState";
import { GetAccountStatus } from "./queries";
import useTutorialsState from "../../../hooks/useTutorialsState";

function SubscriptionAlert({ location }) {
  const history = useHistory();
  const { isLoggedIn } = useAuthState();
  const { getHasCompletedTutorial } = useTutorialsState();
  const hasCompletedPaymentStep = getHasCompletedTutorial(
    "Brand Dashboard Payment Info"
  );
  const { data, loading } = useQuery(GetAccountStatus, {
    skip: !isLoggedIn || !hasCompletedPaymentStep
  });
  const account = data && data.accounts && data.accounts[0];
  const isOpen = !!account && !account.isActive;

  if (
    loading ||
    location.pathname === "/login" ||
    location.pathname === "/forgotPassword" ||
    location.pathname === "/orders" ||
    location.pathname === "/cashout" ||
    location.pathname === "/settings/billing" ||
    location.pathname.startsWith("/influencer") ||
    location.pathname.startsWith("/register") ||
    location.pathname.startsWith("/share") ||
    location.pathname.startsWith("/brand")
  )
    return null;

  return (
    <Alert
      className={styles.subscriptionAlert}
      icon={
        <Icon
          name="warning-sign"
          color="#7a869b"
          size={32}
          className={styles.subscriptionIcon}
        />
      }
      intent="danger"
      isOpen={isOpen}
    >
      <span>Your account has been suspended due to non-payment</span>
      <div className={styles.options}>
        <div className={styles.optionsRow}>
          <Button
            intent={Intent.PRIMARY}
            style={{ marginRight: "6px" }}
            onClick={() => {
              history.push("/orders");
            }}
          >
            View Orders
          </Button>
          <Button
            className={styles.cashOutButton}
            onClick={() => {
              history.push("/cashout");
            }}
          >
            Cashout
          </Button>
        </div>
        <div className={styles.optionsRow}>
          <Button
            minimal
            intent={Intent.PRIMARY}
            className={styles.updatePaymentButtton}
            onClick={() => {
              history.push("/settings/billing");
            }}
          >
            Update Payment Info
          </Button>
        </div>
      </div>
    </Alert>
  );
}

export default withRouter(SubscriptionAlert);
